import { Module } from 'vuex';
import { RootState } from '@/store/types';
import { DistrModerationState } from './types';
import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: DistrModerationState = {
  bulkDistrList: [],
};

export const distr_moderation: Module<DistrModerationState, RootState> = {
  state,
  getters,
  actions,
  mutations
};